export default __webpack_public_path__ + "static/media/135.e3583a1a.png";